module.exports = require("npm:lory.js@2.5.3/dist/lory.js");